import { render, staticRenderFns } from "./VuePopperNew.vue?vue&type=template&id=5d829143&"
import script from "./VuePopperNew.vue?vue&type=script&lang=js&"
export * from "./VuePopperNew.vue?vue&type=script&lang=js&"
import style0 from "./VuePopperNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports